export default "__VITE_ASSET__231af962__"